export type AccountBusinessNameSource = {
  business_name?: string | null;
  local_config?: { business_name?: string | null } | null;
  account_name?: string | null;
  display_name?: string | null;
} | null | undefined;

export function getBusinessName(account: AccountBusinessNameSource): string {
  return account?.business_name ||
    account?.local_config?.business_name ||
    account?.account_name ||
    account?.display_name ||
    "";
}
